<template>
  <div class="select" :class="{'disabled': disabled}">
    <div class="select-block" @click="toggle" v-if="current.name">{{current.name}}</div>
    <div class="select-block place-holder" @click="toggle" v-else>{{placeholder}}</div>
    <transition name="fade" mode="out-in">
      <ucar-mask v-if="showSlider"></ucar-mask>
    </transition>
    <transition name="popup" mode="out-in">
      <slider
        v-if="showSlider"
        @close="change"
        @scrolling="scrolling"
        @scrollend="scrollend"
        @click.stop
        :options="options"
        :value="value"
      ></slider>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.select {
  flex: 1 1 auto;
  display: inline-block;
  height: 100%;

  &.disabled {
    pointer-events: none;
  }
}

.select-block {
  position: relative;
  font-size: $ucar_font_h4;
  text-align: right;
  padding: 30px 40px 30px;
  line-height: 1.25;
  height: 100%;
  color: $ucar_font_color;
}

.select-block::after {
  position: absolute;
  right: 5px;
  top: 50%;
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border-bottom: 2px solid $ucar_font_assist_color;
  border-right: 2px solid $ucar_font_assist_color;
  transform: translate3d(0, -50%, 0) rotate(-45deg);
  box-sizing: border-box;
}

.place-holder {
  color: $ucar_font_assist_color;
}
</style>

<script>
import slider from './slider'

export default {
  data () {
    return {
      showSlider: false,
      current: {},
      scrolled: false
    }
  },
  components: {
    slider
  },
  props: {
    value: [String, Number],
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    options () {
      this.init()
    },
    value () {
      this.init()
    }
  },
  methods: {
    toggle () {
      if (!this.options) return
      setTimeout(() => {
        this.showSlider = !this.showSlider
      }, 300)
    },
    scrolling () {
      this.scrolled = true
    },
    scrollend () {
      this.scrolled = false
    },
    change (item) {
      if (this.scrolled) return
      if (!item) {
        this.toggle()
        return
      }
      this.showSlider = false
      this.current = item
      this.$emit('input', item.value)
    },
    init () {
      if (!this.value && this.value !== 0) return
      let index = -1
      this.options.some((item, i) => {
        if (item.value === this.value) {
          index = i
          return true
        }
        return false
      })
      this.current = index !== -1 ? this.options[index] : {}
      this.$emit('input', this.current.value)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
